import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Link from 'flarum/common/components/Link';
import { illustration } from '../../common/illustrations';

/**
 * /u/{username}/results  "My results" on a member's profile: their saved quiz results (Japa Compass and later
 * ones). Only the member themselves can see it; the tab isn't shown to anyone else, and the API only ever
 * returns the signed-in member's own results.
 */
export default class UserResultsPage extends UserPage {
  oninit(vnode) {
    super.oninit(vnode);
    this.results = null;
    this.loadUser(m.route.param('username'));
  }
  show(user) {
    super.show(user);
    if (this.isOwn() && this.results === null) {
      app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/assessment-results',
        errorHandler: () => {}
      }).then(res => this.results = res.results).catch(() => this.results = []).finally(() => m.redraw());
    }
  }
  isOwn() {
    return !!(app.session.user && this.user && app.session.user.id() === this.user.id());
  }
  content() {
    if (!this.isOwn()) {
      return m("p", {
        className: "VAssessMine-empty"
      }, "Results are private to each member.");
    }
    if (this.results === null) return m(LoadingIndicator, null);
    if (!this.results.length) {
      return m("div", {
        className: "VAssessMine-empty"
      }, m("span", {
        className: "VAssessMine-pic",
        "aria-hidden": "true"
      }, m.trust(illustration('compass'))), m("p", null, "No saved results yet. Take the Japa Compass on okjapa.com to find which country suits you best."));
    }
    return m("div", {
      className: "VAssessMine"
    }, m("p", {
      className: "VAssessMine-note"
    }, "Only you can see this page."), m("ul", {
      className: "VAssessMine-list"
    }, this.results.map(r => m("li", null, m(Link, {
      className: "VAssessMine-item",
      href: app.route('voucha-assessments.result', {
        id: r.id
      })
    }, m("span", {
      className: "VAssessMine-pic",
      "aria-hidden": "true"
    }, m.trust(illustration('compass'))), m("span", null, m("strong", null, r.name), m("small", null, "Saved ", new Date(r.createdAt).toLocaleDateString(undefined, {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }))), m("i", {
      className: "fas fa-chevron-right",
      "aria-hidden": "true"
    }))))));
  }
}
flarum.reg.add('voucha-assessments', 'forum/components/UserResultsPage', UserResultsPage);